import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { translate } from '../../utils/useful'
import { userPages } from '../../variables/userPages'
import { siteTheme } from '../../variables/config'

const colors = siteTheme.primaryColors

class SignUpFormStep extends React.Component {
    state = {
        isLoading: false,
        errors: {}
    }

    getFormHeaders = () => {
        const userType = this.props.initData?.userType
        if (userType && userPages[userType]) {
            return userPages[userType].headers
        }
        return []
    }

    validateForm = (data) => {
        let errors = {}
        
        if (data.password && data.confirmPassword && data.password !== data.confirmPassword) {
            errors.confirmPassword = translate('Passwords do not match')
        }

        if (data.password && data.password.length < 6) {
            errors.password = translate('Password must be at least 6 characters')
        }

        return errors
    }

    submitForm = () => {
        let data = this.form.getForm()
        if (data) {
            let errors = this.validateForm(data)
            if (Object.keys(errors).length > 0) {
                this.setState({ errors })
                return
            }

            this.setState({ isLoading: true, errors: {} })
            this.props.setData(data, () => {
                if (this.props.submitSignup) {
                    this.props.submitSignup((result, error) => {
                        this.setState({ isLoading: false })
                        if (error) {
                            this.setState({ errors: error })
                        } else {
                            if (this.props.stageManager) {
                                this.props.stageManager.nextStage()
                            }
                        }
                    })
                }
            })
        }
    }

    goBack = () => {
        if (this.props.stageManager) {
            this.props.stageManager.lastStage()
        }
    }

    render() {
        const userType = this.props.initData?.userType
        const userPage = userType ? userPages[userType] : null

        if (!userPage) {
            return (
                <div className="flexcc flex-column">
                    <p style={{ color: '#FF3B30' }}>{translate('Please select user type first')}</p>
                </div>
            )
        }

        return (
            <div className="flexcc flex-column">
                <h2 className="mt-0 mb-2" style={{ fontSize: 24, color: colors.main1 }}>{translate('Complete Your Information')}</h2>
                <p className="mb-4" style={{ fontSize: 14, color: '#789', maxWidth: 500, textAlign: 'center' }}>
                    {translate('Please fill in all required information to complete your registration')}
                </p>

                <div className="w-100" style={{ maxWidth: 600 }}>
                    <FormViewer 
                        ref={el => this.form = el} 
                        headers={this.getFormHeaders()} 
                        initData={this.props.initData} 
                        errors={this.state.errors} 
                        inputClass={'modern-input'}
                    />

                    <div className="d-flex gap-3 justify-content-center align-items-center mt-4 mb-4 mx-2" style={{ flexWrap: 'wrap' }}>
                        <button
                            onClick={this.goBack}
                            style={{
                                background: `linear-gradient(135deg, ${colors.main3}50, ${colors.main3}60)`,
                                border: `2px solid ${colors.main3}80`,
                                borderRadius: 50,
                                padding: '12px 35px',
                                fontSize: 15,
                                fontWeight: 600,
                                color: colors.main1,
                                cursor: 'pointer',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: `0 2px 8px ${colors.main3}30`,
                                minWidth: 120,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 8
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${colors.main3}65, ${colors.main3}75)`
                                e.currentTarget.style.borderColor = colors.main3
                                e.currentTarget.style.transform = 'translateY(-2px)'
                                e.currentTarget.style.boxShadow = `0 4px 12px ${colors.main3}40`
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${colors.main3}50, ${colors.main3}60)`
                                e.currentTarget.style.borderColor = colors.main3 + '80'
                                e.currentTarget.style.transform = 'translateY(0)'
                                e.currentTarget.style.boxShadow = `0 2px 8px ${colors.main3}30`
                            }}
                        >
                            <span>←</span> {translate('Back')}
                        </button>
                        <LoaderButton
                            onClick={this.submitForm}
                            isLoading={this.state.isLoading}
                            text={translate('Submit')}
                            type={"Oval"}
                            className="mt-0"
                            buttonStyle={{ 
                                outline: 'none', 
                                background: `linear-gradient(135deg, ${colors.main1} 0%, ${colors.main1} 75%, ${colors.main2} 100%)`,
                                cursor: 'pointer',
                                padding: '12px 50px', 
                                borderRadius: 50, 
                                fontSize: 15, 
                                fontWeight: 600, 
                                color: '#fff', 
                                border: 'none',
                                boxShadow: `0 4px 20px ${colors.main1}40, 0 2px 8px ${colors.main1}20`,
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                minWidth: 120
                            }}
                            width={80}
                            height={70}
                            color={'#fff'}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default SignUpFormStep

